import { render } from "./ClientValidationTab.vue?vue&type=template&id=77abfd8b"
import script from "./ClientValidationTab.vue?vue&type=script&lang=js"
export * from "./ClientValidationTab.vue?vue&type=script&lang=js"

import "./ClientValidationTab.vue?vue&type=style&index=0&id=77abfd8b&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__